import { Badge, Button } from '@accure/ui';
import { Kanban } from 'lucide-react';

import type { AlertTask } from '@/alerts/entities/task';
import { Link } from '@/components/ui/link';
import { Tooltip } from '@/components/ui/tooltip';
import { PageUrlKey } from '@/entities/page-url-key';
import { useFeatureFlag } from '@/hooks/use-feature-flag';

export type TaskPreviewProps = {
  task?: AlertTask;
  className?: string;
};

export function TaskPreview({ task, className }: TaskPreviewProps) {
  const featureFlag = useFeatureFlag();
  if (!task || !featureFlag('taskmanager')) {
    return null;
  }

  return (
    <div data-testid="alerts-task-preview" data-task-status={task.status}>
      <Tooltip content={<TaskStatusTooltipContent task={task} />} delay>
        <Link
          to={{
            pathname: `/${PageUrlKey.TASKS}`,
            search: new URLSearchParams({ id: task.id }).toString(),
          }}
        >
          <Button variant="ghost" size="icon" className={className}>
            <Kanban className="size-4" />
          </Button>
        </Link>
      </Tooltip>
    </div>
  );
}

function TaskStatusTooltipContent({ task }: { task: AlertTask }) {
  return (
    <div className="flex items-center gap-2">
      <div className="text-xs">Task status:</div>
      <div>
        <Badge variant="secondary">{task.status}</Badge>
      </div>
    </div>
  );
}
